import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  const menu = [
    {
      icon: 'config',
      name: i18n.t('sedes.entity_name'),
      path: 'masters/society/locations',
      use_parent_params: true,
      params_required: ['id', 'idSede'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'masters/society/locations/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        // {
        //   name: i18n.t('contact_email.header'),
        //   path: 'masters/society/locations/contactemails',
        //   params,
        //   registerNavFromMenu: false,
        //   disabled: params.idSede === -1 || params.idSede === '-1',
        //   sc: [] // shorcuts
        // },
        {
          name: i18n.t('agenda.cuentas_bancarias'),
          path: 'masters/society/locations/bankaccounts',
          params,
          registerNavFromMenu: false,
          disabled: params.idSede === -1 || params.idSede === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('administrativecenter.header'),
          path: 'masters/society/locations/administrativecenters',
          params,
          registerNavFromMenu: false,
          disabled: params.idSede === -1 || params.idSede === '-1',
          invisible: params.idSede === -1 || params.idSede === '-1',
          sc: [], // shorcuts
          info: i18n.t('administrativecenter.info_header')
        },
      ]
    }
  ]
  if (params.issuingCreation) {
    menu[0].sc = menu[0].sc.slice(0, 1)
  }
  return menu
}
